import React from "react";
import { ArrowRight } from "lucide-react";

export default function Hero() {
  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative bg-white pt-36 lg:pt-44 pb-24 lg:pb-32 border-b hairline overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://customer-assets.emergentagent.com/job_downside-first/artifacts/vxpd97er_image.png"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* Lighter fade on the left so the photo reads clearly on the right */}
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/65 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-b from-transparent to-white" />
        <div className="absolute inset-0 bg-[#1f3a2e]/5 mix-blend-multiply" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="lg:col-span-8 wc-fade">
            <p className="eyebrow mb-8">Vancouver, Canada</p>
            <p className="text-[#1f3a2e] text-2xl sm:text-3xl lg:text-[40px] leading-[1.15] tracking-tight max-w-2xl font-serif-display font-light wc-fade-d1">
              Wintercove invests in durable, income-producing real estate.
              We protect principal first and compound value through every market cycle.
            </p>
            <div className="mt-12 flex flex-wrap items-center gap-5 wc-fade-d2">
              <button
                type="button"
                data-testid="hero-cta-button"
                onClick={scrollToContact}
                className="btn-primary"
              >
                Get in contact with us
                <ArrowRight size={16} strokeWidth={1.25} />
              </button>
              <a
                href="#what-we-do"
                data-testid="hero-secondary-link"
                className="text-[13px] tracking-[0.18em] uppercase text-[#1f3a2e] hover:text-[#5e6e63] transition-colors"
              >
                What we do →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
